export default "__VITE_ASSET__a5f3b121__"